/**
 * named by
 * http://chir.ag/projects/name-that-color/
 */
const colors = {
  shakespeare: '#47A3CC',
  seagull: '#80D4EA',
  fountainBlue: '#4DB6AC',
  lemonGinger: '#AFB42B',
  gold: '#FFD600',
  orangePeel: '#FF9800',
  burntSienna: '#EF5350',
  lilacBush: '#9575CD',
  cement: '#8D6E63',
  doveGray: '#616161',
  towerGray: '#B0BEC5',
  salomie: '#FFE082',
  buttercup: '#F39C12',
  lightBlue: '#C1E2E4',
}

export default {
  namespaced: true,
  state: {
    ...colors,
    allColors: [
      colors.shakespeare,
      colors.seagull,
      colors.fountainBlue,
      colors.lemonGinger,
      colors.gold,
      colors.orangePeel,
      colors.burntSienna,
      colors.lilacBush,
      colors.cement,
      colors.doveGray,
      colors.towerGray,
    ],
  },
  mutations: {},
  getters: {
    customer(state) {
      return [state.shakespeare, state.seagull]
    },
    route(state) {
      return state.allColors.slice(0, -1)
    },
    call(state) {
      return [state.shakespeare, state.towerGray]
    },
    course(state) {
      return state.allColors
    },
    courseRanking(state) {
      return {
        first: state.shakespeare,
        other: state.towerGray,
      }
    },
    chartBox(state) {
      return {
        first: state.shakespeare,
        other: state.towerGray,
      }
    },
    tag(state) {
      return state.allColors
    },
    cancel(state) {
      return {
        qty: [state.shakespeare, state.seagull],
        rate: [state.orangePeel],
      }
    },
    progress(state) {
      return [state.shakespeare, state.buttercup, state.salomie]
    },
    target(state) {
      return [state.shakespeare, state.lightBlue]
    },
  },
  actions: {},
}
